import * as React from 'react'

import { StyledSubmitButton } from './SubmitButton.glamorous'

export type Props = {
  disabled: boolean;
  type: string;
}

export const SubmitButton: React.SFC<Props> = ({ children, ...restProps }) => {
  return (
    <StyledSubmitButton {...restProps}>{children}</StyledSubmitButton>
  )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/SubmitButton/SubmitButton.tsx